/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderSubtotalsListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: OrderSubtotalsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { OrderSubtotalsData, OrderSubtotalsService } from './OrderSubtotals.service';
import { OrderSubtotalsSearchComponent }  from './OrderSubtotalsSearch.component';

@Component({
	selector: 'my-OrderSubtotals',
	template: require('./OrderSubtotalsList.component.html'),
	providers: [OrderSubtotalsService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class OrderSubtotalsListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	OrderSubtotalsList: OrderSubtotalsData[];
	newOrderSubtotals: OrderSubtotalsData;
	selectedOrderSubtotals: OrderSubtotalsData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(OrderSubtotalsSearchComponent) filterComponent: OrderSubtotalsSearchComponent;

	sortExpression: string = "OrderID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private OrderSubtotalsService: OrderSubtotalsService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newOrderSubtotals = new OrderSubtotalsData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.OrderSubtotalsService.getAll().subscribe(record => this.OrderSubtotalsList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getOrderSubtotalsByPaging();

		/*
		this.OrderSubtotalsList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getOrderSubtotals() {
		this.OrderSubtotalsService.getAll()
			.subscribe(data => this.OrderSubtotalsList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on OrderSubtotalsSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getOrderSubtotalsByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getOrderSubtotalsByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getOrderSubtotalsByPaging();
	}
	
	// Get records by paging
	getOrderSubtotalsByPaging() {
		this.OrderSubtotalsService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.OrderSubtotalsList=data.OrderSubtotalsList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addOrderSubtotals() {
		this.OrderSubtotalsService.addOrderSubtotalsData(this.newOrderSubtotals).subscribe(record => console.log(record));
		this.getOrderSubtotals();
	}
  
	// Updates existing record
	updateOrderSubtotals() {
		this.OrderSubtotalsService.updateOrderSubtotalsData(this.selectedOrderSubtotals).subscribe(record => console.log(record));
		this.getOrderSubtotals();
	}

	// Deletes record with specified id
	deleteOrderSubtotals(id: string) {
		if (window.confirm('Are you sure you want to delete this OrderSubtotals?') == true)
		{
			this.OrderSubtotalsService.deleteOrderSubtotals(id)
			.subscribe(data => this.getOrderSubtotals(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getOrderSubtotalsByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getOrderSubtotalsByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getOrderSubtotalsByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getOrderSubtotalsByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: OrderSubtotalsData) {
		this.router.navigate(['/OrderSubtotals', item.OrderID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: OrderSubtotalsData) {
		this.router.navigate(['/OrderSubtotals/Details', item.OrderID]);
	}

	// Set record as selected
	SelectOrderSubtotals(item: OrderSubtotalsData) {
		this.selectedOrderSubtotals = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: OrderSubtotalsData) {
		return item.OrderID === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderSubtotals/OrderSubtotalsList.component.ts